import React, { useState } from 'react';

//helpers
import { capitaliseFirstLetter, Truncate } from  '@/helpers/Text';
import { getContentTypeString, getPlaceholderImage } from  '@/helpers/Content';

//components
import LoadingSpinner from '../search/LoadingSpinner/LoadingSpinner';
import { getImageAsset } from  '@/helpers/Images';


const ContentImageAndName = ({image, contentId, contentTitle, contentType, truncate}: {image: string, contentId: number, contentTitle: string, contentType: number, truncate: number}) => {
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    return (
        <span className='content-image-name-wrapper'>
            {(image && !hasError)
                ?   (<img className='featured-image' src={getImageAsset(60, image)} alt="" onError={() => {setHasError(true); setIsLoading(false)}} onLoad={() => setIsLoading(false)} />)
                :   <div className="placeholder-wrapper">
                        {(isLoading && image)
                            ?   (<LoadingSpinner size={18}/> )
                            :   (<img className="placeholder-image" src={getPlaceholderImage(contentType)} alt="" />)
                        }
                    </div>
            }
            
            <div className='text-wrapper'>
                <a className='draft-title' href={`./Content/Index/${contentId}`}>{Truncate(contentTitle, truncate)}</a>

                <span className="content-type">{capitaliseFirstLetter(getContentTypeString(contentType))}</span>
            </div>
        </span>
    )
}

export default ContentImageAndName